import React, { Suspense, lazy } from 'react';
import { Box, Flex, Spinner, useColorModeValue } from '@chakra-ui/react';
import RequirePermission from 'components/auth/RequirePermission';
import { AttendanceNfcProvider } from 'contexts/AttendanceNfcContext';

const Schedule = lazy(() => import('views/admin/schedule'));

export default function ScheduleStandaloneLayout() {
  const pageBg = useColorModeValue('secondaryGray.300', 'navy.900');

  return (
    <AttendanceNfcProvider>
      <Box minH="100vh" w="100vw" maxW="100vw" overflowX="hidden" bg={pageBg}>
        <RequirePermission>
          <Suspense
            fallback={
              <Flex minH="100vh" align="center" justify="center">
                <Spinner size="xl" />
              </Flex>
            }
          >
            <Schedule standalone />
          </Suspense>
        </RequirePermission>
      </Box>
    </AttendanceNfcProvider>
  );
}
